import {PsdkConst} from "../../types";

export enum ClauseType {
  TEXT = 'TEXT',
  BINARY = 'BINARY',
  NEWLINE = 'NEWLINE',
  NONE = 'NONE',
}

export class CommandClause {
  /**
   * Clause type
   * @private
   */
  private readonly _type: ClauseType;
  /**
   * Text command
   * @private
   */
  private readonly _text?: string;
  /**
   * Charset
   * @private
   */
  private readonly _charset?: string;
  /**
   * Binary command
   * @private
   */
  private readonly _binary?: Uint8Array;

  private constructor(
    type: ClauseType,
    text?: string,
    charset?: string,
    binary?: Uint8Array
  ) {
    this._type = type;
    this._text = text;
    this._charset = charset;
    this._binary = binary;
  }

  public static text(
    command: string,
    charset: string = PsdkConst.DEF_CHARSET
  ): CommandClause {
    return new CommandClause(
      ClauseType.TEXT,
      command,
      charset,
      undefined,
    )
  }

  public static binary(binary: Uint8Array): CommandClause {
    return new CommandClause(
      ClauseType.BINARY,
      undefined,
      undefined,
      binary,
    )
  }

  public static newline(): CommandClause {
    return new CommandClause(
      ClauseType.NEWLINE,
      undefined,
      undefined,
      PsdkConst.DEF_NEWLINE_BINARY,
    )
  }

  public static none(): CommandClause {
    return new CommandClause(
      ClauseType.NONE,
      undefined,
      undefined,
      undefined,
    )
  }

  get type(): ClauseType {
    return this._type
  }

  get text(): string | undefined {
    return this._text
  }

  get charset(): string | undefined {
    return this._charset
  }

  get binary(): Uint8Array | undefined {
    return this._binary
  }

}
